import styled from 'styled-components';

const Wrapper = styled.div`
    position: fixed;
    top: 20px;
    z-index: 101;
    width: calc(100% - 20px);
    transition: opacity 1s ease-out, visibility 1s ease-out;
    visibility: ${props => props.isVisible ? "visible" : "hidden"};
    opacity: ${props => props.isVisible ? "1" : "0"}
    @media only screen and (min-width: 1024px) {
        width: calc(100% - 260px);
        top: 100px;
        left: 260px;
        z-index: 99 !important;
    }
`

export default Wrapper;